

import { useState } from "react";
import { Box, Button, } from "@mui/material";
import RedeemResponse from "./RedeemResponse";
import RedeemQuote from "./RedeemQuote";

export default function Mmtc() {
  const [activeTab, setActiveTab] = useState("Redeem Response");
  return (
    <>
      <Box>
        <Box display="flex" justifyContent="center" gap={2} mb={2}>
          <Button
            variant={
              activeTab === "Redeem Response"
                ? "contained"
                : "outlined"
            }
            onClick={() => setActiveTab("Redeem Response")}
          // sx={{ marginRight: 2 }}
          >
            Redeem Response
          </Button>
          <Button
            variant={
              activeTab === "Redeem Quote" ? "contained" : "outlined"
            }
            onClick={() => setActiveTab("Redeem Quote")}
          >
            Redeem Quote
          </Button>

        </Box>

        {activeTab === "Redeem Response" && (
          <RedeemResponse />
        )}
        {activeTab === "Redeem Quote" && (
          <RedeemQuote />
        )}

      </Box>


    </>
  );
}
